import Cookies from 'js-cookie'

const addNewsIdToImpressionCookie = ({ newsId }) => {
  const COOKIE_NAME = 'aws_personalize_impression'
  const cookieValue = Cookies.get(COOKIE_NAME)
  let newsIdSet = new Set()

  if (cookieValue !== undefined) {
    newsIdSet = new Set(JSON.parse(cookieValue))
  }

  newsIdSet.add(newsId)
  Cookies.set(
    COOKIE_NAME,
    JSON.stringify(Array.from(newsIdSet)),
    { expires: 1 / 24 }, // 1 小時
  )
}

export default function observeNewsImpression({
  listElementSelector,
  itemElementSelector,
}) {
  const isListElementExist = document.querySelector(listElementSelector) !== null
  if (!isListElementExist) {
    return () => {}
  }

  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const newsId = entry.target.getAttribute('data-news-id')
        addNewsIdToImpressionCookie({ newsId })
        observer.unobserve(entry.target)
      }
    })
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  })

  // observe 目前已在頁面上的 item
  Array.from(document.querySelectorAll(itemElementSelector))
    .forEach((item) => intersectionObserver.observe(item))

  // mutationObserver 用來監控「查看更多新聞」展開的新 item
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type !== 'childList') return
      if (mutation.addedNodes.length === 0) return
      if (mutation.addedNodes[0].classList === undefined) return
      if (mutation.addedNodes[0].classList.contains(itemElementSelector.replace('.'))) return
      intersectionObserver.observe(mutation.addedNodes[0])
    })
  })
  mutationObserver.observe(
    document.querySelector(listElementSelector),
    { childList: true, attributeFilter: ['data-news-id'] },
  )

  const disconnectAll = () => {
    intersectionObserver.disconnect()
    mutationObserver.disconnect()
  }
  return disconnectAll
}
